import { ITopic } from "@/models/Topic.model";

const state = { topics: false };
const getters = {
  // @ts-ignore
  getTopics: state => state.topics
};

const mutations = {
  // @ts-ignore
  setTopics(state, topics: ITopic[]) {
    state.topics = topics;
  }
};

const actions = {};

export default { state, getters, mutations, actions };
